var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-modal', {
    attrs: {
      "hide-header": "",
      "hide-footer": "",
      "centered": "",
      "no-close-on-backdrop": "",
      "size": "lg"
    },
    model: {
      value: _vm.showDialog,
      callback: function ($$v) {
        _vm.showDialog = $$v;
      },
      expression: "showDialog"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": _vm.alert.show
    }
  }, [_vm._v(" " + _vm._s(_vm.alert.message) + " ")]), _c('b-row', {
    staticClass: "mb-4",
    attrs: {
      "align-h": "between"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/icon_logo_violet.svg"),
      "alt": ""
    }
  })]), _c('b-col', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "tw-text-eclipse",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "x-circle",
      "font-scale": "1.5"
    }
  })], 1)])], 1), _c('b-row', {
    staticClass: "mt-4 pr-4"
  }, [_c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "cols": "4"
    }
  }, [_c('span', {
    staticClass: "h2 tw-text-primary"
  }, [_vm._v("Doctor Settings")])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "cols": "8"
    }
  }, [_c('b-col', {
    staticClass: "mb-4"
  }, [_c('b-row', [_c('b-col', [_c('div', {
    staticClass: "text-primary"
  }, [_vm._v(" Doctor ")]), _c('div', [_vm._v("Dr. " + _vm._s(_vm.rowData.firstname) + " " + _vm._s(_vm.rowData.lastname))])])], 1)], 1), _c('b-col', [_c('b-row', [_c('b-col', [_c('b-row', [_c('b-col', {
    staticClass: "text-primary"
  }, [_vm._v(" Active ")]), _c('b-col', {
    staticClass: "text-primary"
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.isValidRole || _vm.loadingPatientCount || _vm.isDeactivationBlocked,
      "switch": ""
    },
    model: {
      value: _vm.canAcceptPatient,
      callback: function ($$v) {
        _vm.canAcceptPatient = $$v;
      },
      expression: "canAcceptPatient"
    }
  })], 1)], 1), _vm.isDeactivationBlocked ? _c('small', {
    staticClass: "d-block text-muted mt-2"
  }, [_vm._v(" The doctor currently has patients assigned. Please reassign all patients before changing the doctor's status to Inactive. ")]) : _vm._e()], 1)], 1), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', [_c('b-row', [_c('b-col', {
    staticClass: "text-primary"
  }, [_vm._v(" Disable Patient Accept ")]), _c('b-col', {
    staticClass: "text-primary"
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.isValidRole,
      "switch": ""
    },
    model: {
      value: _vm.isAcceptPatientDisabled,
      callback: function ($$v) {
        _vm.isAcceptPatientDisabled = $$v;
      },
      expression: "isAcceptPatientDisabled"
    }
  })], 1)], 1)], 1)], 1), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', [_c('b-row', [_c('b-col', {
    staticClass: "text-primary"
  }, [_vm._v(" Disable Patient Reassignment ")]), _c('b-col', {
    staticClass: "text-primary"
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.isManager,
      "switch": ""
    },
    on: {
      "change": _vm.onReassignmentToggleChange
    },
    model: {
      value: _vm.isReassignmentDisabled,
      callback: function ($$v) {
        _vm.isReassignmentDisabled = $$v;
      },
      expression: "isReassignmentDisabled"
    }
  })], 1)], 1), _vm.isReassignmentDisabled ? _c('b-row', {
    staticClass: "mt-2 ml-1"
  }, [_c('b-col', [_c('b-form-checkbox', {
    staticClass: "mb-1",
    attrs: {
      "value": "STATE_TRANSFER",
      "disabled": !_vm.isManager
    },
    on: {
      "change": _vm.onSubFlagChange
    },
    model: {
      value: _vm.disabledInOptions,
      callback: function ($$v) {
        _vm.disabledInOptions = $$v;
      },
      expression: "disabledInOptions"
    }
  }, [_c('small', [_vm._v("Transfer State")])]), _c('b-form-checkbox', {
    staticClass: "mb-1",
    attrs: {
      "value": "OOO",
      "disabled": !_vm.isManager
    },
    on: {
      "change": _vm.onSubFlagChange
    },
    model: {
      value: _vm.disabledInOptions,
      callback: function ($$v) {
        _vm.disabledInOptions = $$v;
      },
      expression: "disabledInOptions"
    }
  }, [_c('small', [_vm._v("OOO Reassignments")])]), _c('b-form-checkbox', {
    staticClass: "mb-1",
    attrs: {
      "value": "GENERAL_PATIENT_TRANSFER",
      "disabled": !_vm.isManager
    },
    on: {
      "change": _vm.onSubFlagChange
    },
    model: {
      value: _vm.disabledInOptions,
      callback: function ($$v) {
        _vm.disabledInOptions = $$v;
      },
      expression: "disabledInOptions"
    }
  }, [_c('small', [_vm._v("General Patient Reassignments")])]), _c('b-form-checkbox', {
    staticClass: "mb-1",
    attrs: {
      "value": "PERMANENT",
      "disabled": !_vm.isManager
    },
    on: {
      "change": _vm.onSubFlagChange
    },
    model: {
      value: _vm.disabledInOptions,
      callback: function ($$v) {
        _vm.disabledInOptions = $$v;
      },
      expression: "disabledInOptions"
    }
  }, [_c('small', [_vm._v("Permanent Reassignment")])])], 1)], 1) : _vm._e()], 1)], 1), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', [_c('b-row', [_c('b-col', {
    staticClass: "text-primary"
  }, [_vm._v(" Override Reassignment Restriction ")]), _c('b-col', {
    staticClass: "text-primary"
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.isManager,
      "switch": ""
    },
    model: {
      value: _vm.canOverrideReassignmentRule,
      callback: function ($$v) {
        _vm.canOverrideReassignmentRule = $$v;
      },
      expression: "canOverrideReassignmentRule"
    }
  })], 1)], 1)], 1)], 1), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', [_c('b-row', [_c('b-col', {
    staticClass: "text-primary"
  }, [_vm._v(" State ")]), _c('b-col', {
    staticClass: "text-primary"
  }, [_vm._v(" Max Daily Accept ")])], 1)], 1)], 1), _c('div', {
    staticStyle: {
      "max-height": "450px",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    }
  }, [_c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', _vm._l(_vm.rowData.coveredstate, function (state) {
    return _c('b-row', {
      key: state.state
    }, [_c('b-col', {
      staticClass: "d-flex align-items-center"
    }, [_vm._v(" " + _vm._s(state.state) + " ")]), _c('b-col', [_c('b-form-input', {
      attrs: {
        "type": "text",
        "inputmode": "numeric",
        "formatter": _vm.getIntegerValue
      },
      model: {
        value: _vm.limits[state.state],
        callback: function ($$v) {
          _vm.$set(_vm.limits, state.state, $$v);
        },
        expression: "limits[state.state]"
      }
    })], 1)], 1);
  }), 1)], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "cols": "8"
    }
  }, [_c('b-col', [_c('div', {
    staticClass: "text-primary"
  }, [_vm._v(" Versions ")]), _c('b-row', [_c('b-col', {
    staticClass: "d-flex align-items-center"
  }, [_vm._v(" 10 Week Follow-up ")]), _c('b-col', [_c('v-select', {
    attrs: {
      "options": [{
        label: 'v3',
        code: 'fv-3'
      }, {
        label: 'v4',
        code: 'fv-4'
      }, {
        label: 'v6',
        code: 'fv-6'
      }, {
        label: 'v7',
        code: 'fv-7'
      }],
      "reduce": version => version.code
    },
    model: {
      value: _vm.version10Week,
      callback: function ($$v) {
        _vm.version10Week = $$v;
      },
      expression: "version10Week"
    }
  })], 1)], 1), _vm.version10Week === 'fv-3' ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" v3 - Basic short follow up flow with no conditional logic. ")]) : _vm._e(), _vm.version10Week === 'fv-4' ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" v4 - Large flow with complex logic conditions for if patient is unsure they want to continue. ")]) : _vm._e(), _c('b-row', [_c('b-col', {
    staticClass: "d-flex align-items-center"
  }, [_vm._v(" 1 Year Follow-up ")]), _c('b-col', [_c('v-select', {
    attrs: {
      "options": [{
        label: 'v3',
        code: 'fv-3'
      }, {
        label: 'v4',
        code: 'fv-4'
      }, {
        label: 'v6',
        code: 'fv-6'
      }, {
        label: 'v7',
        code: 'fv-7'
      }],
      "reduce": version => version.code
    },
    model: {
      value: _vm.version1Year,
      callback: function ($$v) {
        _vm.version1Year = $$v;
      },
      expression: "version1Year"
    }
  })], 1)], 1), _vm.version1Year === 'fv-3' ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" v3 - Basic short follow up flow with no conditional logic. ")]) : _vm._e(), _vm.version1Year === 'fv-4' ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" v4 - Large flow with complex logic conditions for if patient is unsure they want to continue. ")]) : _vm._e()], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }), _c('b-col', {
    staticClass: "mt-3",
    attrs: {
      "cols": "8"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary",
      "pill": "",
      "block": "",
      "disabled": _vm.processing
    },
    on: {
      "click": _vm.setDoctorSettings
    }
  }, [_vm.processing ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _c('span', [_vm._v("Confirm")])], 1), _c('b-button', {
    attrs: {
      "variant": "outline-dark",
      "pill": "",
      "block": ""
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(" Back ")])], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "hide-header": "",
      "hide-footer": "",
      "centered": "",
      "size": "md"
    },
    model: {
      value: _vm.showUnsavedDialog,
      callback: function ($$v) {
        _vm.showUnsavedDialog = $$v;
      },
      expression: "showUnsavedDialog"
    }
  }, [_c('div', {
    staticClass: "p-2"
  }, [_c('p', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" You have unsaved changes in Doctor Settings. If you exit now, your changes will be discarded. ")]), _c('p', [_vm._v("Do you want to continue?")]), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', [_c('b-button', {
    attrs: {
      "variant": "outline-dark",
      "pill": "",
      "block": ""
    },
    on: {
      "click": function ($event) {
        _vm.showUnsavedDialog = false;
      }
    }
  }, [_vm._v(" Cancel ")])], 1), _c('b-col', [_c('b-button', {
    attrs: {
      "variant": "secondary",
      "pill": "",
      "block": ""
    },
    on: {
      "click": _vm.confirmClose
    }
  }, [_vm._v(" Continue ")])], 1)], 1)], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };